import useApi from './useApi';
import { useAppContext } from '../store/AppContext';

const useMediaService = () => {
  const { api } = useApi();
  const [{ adminType }] = useAppContext();

  const pathByType = {
    platform: 'platform-medias',
    establishment: 'establishments/own/establishment-medias',
  };

  const postUploadFile = (file) => api({
    method: 'post',
    url: '/file-upload/v1/files',
    data: file,
  });

  const getMedias = () => api({
    method: 'get',
    url: `/product-marketing/v1/${pathByType[adminType]}`,
  });

  const postMedia = ({ name, fileToken }) => api({
    method: 'post',
    url: `/product-marketing/v1/${pathByType[adminType]}`,
    data: {
      name,
      fileToken,
    },
  });

  const deleteMedia = (mediaId) => api({
    method: 'post',
    url: `/product-marketing/v1/${pathByType[adminType]}/${mediaId}:archive`,
  });

  return {
    postUploadFile,
    getMedias,
    postMedia,
    deleteMedia,
  };
};

export default useMediaService;
